import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import { Link, navigate } from '@reach/router';
import Menu from '../menu/menu';
import PersonOutline from '@material-ui/icons/PersonOutline';
import FavoriteBorder from '@material-ui/icons/FavoriteBorder';
import classes from './header.module.scss';
import { Query } from 'react-apollo';
import Badge from '@material-ui/core/Badge';
import Mail from '@material-ui/icons/MailOutline';
import { GET_CHATS } from '../../queries';
import NewMessagesSub from '../new-messages-sub/new-messages-sub';
import Search from '../search/search';

const Header = () => {
  return (
    <div className={classes.header}>
      <div className={classes.flex}>
        <Menu />
        <Link to="/" className={classes.appTitle}>
          Pastry
        </Link>
      </div>
      <div className={classes.flex}>
        <Search />
        <IconButton
          data-e2e-id="favourites-btn"
          onClick={() => navigate('/favorites')}
        >
          <FavoriteBorder className={classes.headerIcon} />
        </IconButton>
        {localStorage.getItem('token') ? (
          <IconButton
            data-e2e-id="messages-btn"
            onClick={() => navigate('/mailbox')}
          >
            <NewMessagesSub />
            <Query query={GET_CHATS}>
              {({ loading, error, data }) => {
                if (loading || error) {
                  return <Mail className={classes.headerIcon} />;
                }

                const unread = data.userChats.reduce(
                  (total, chat) => total + chat.unread,
                  0
                );

                return (
                  <Badge
                    badgeContent={unread}
                    max={99}
                    classes={{ badge: classes.badge }}
                  >
                    <Mail className={classes.headerIcon} />
                  </Badge>
                );
              }}
            </Query>
          </IconButton>
        ) : null}
        <Link
          to={localStorage.getItem('token') ? '/user-profile' : '/login'}
          style={{ textDecoration: 'none' }}
        >
          <IconButton data-e2e-id="profile-btn">
            <PersonOutline className={classes.headerIcon} />
          </IconButton>
        </Link>
      </div>
    </div>
  );
};

export default Header;
